
import {timeIsValid} from 'helpers/date'
import BaseModel from 'models/BaseModel'

export default class Shift extends BaseModel {

  // 時間のバリデーション
  get isTimeValid() {
    return timeIsValid(this.begin_time, this.end_time)
  }
}
